import { Music, Calendar, Heart, Award, Users, Check } from 'lucide-react';
import SEOLandingPage from '../../components/seo/SEOLandingPage';

export default function LivemusikBuchenSchweiz() {
  return (
    <SEOLandingPage
      title="Livemusik buchen Schweiz | jamnation - Bands für Events"
      description="Livemusik für dein Event buchen in der Schweiz. Professionelle Bands für Hochzeiten, Firmenevents, Geburtstage und mehr. Direkt buchen ohne Agentur."
      h1="Livemusik buchen in der Schweiz"
      heroText="Mach dein Event unvergesslich mit Live-Musik. Finde und buche die perfekte Band für Hochzeiten, Firmenevents, private Feiern und Konzerte – direkt und unkompliziert."
      keywords={[
        'livemusik buchen schweiz',
        'band buchen schweiz',
        'hochzeitsband buchen',
        'firmenband schweiz',
        'livemusik event schweiz',
        'partyband buchen',
        'band für hochzeit schweiz',
        'coverband buchen schweiz',
      ]}
      locationName="Schweizweit"
      ctaButtons={[
        {
          text: 'Bands entdecken',
          link: '/bands',
          primary: true,
        },
        {
          text: 'Buchungsanfrage senden',
          link: '/book-band',
        },
      ]}
      features={[
        {
          icon: Heart,
          title: 'Hochzeiten',
          description:
            'Die perfekte Hochzeitsband für den schönsten Tag. Von Dinner-Musik bis Party-Kracher – Bands für jeden Teil deiner Hochzeit.',
          link: '/bands',
        },
        {
          icon: Users,
          title: 'Firmenevents',
          description:
            'Professionelle Bands für Firmenfeiern, Jubiläen, Weihnachtsfeste und Corporate Events. Seriös, zuverlässig und unterhaltsam.',
          link: '/bands',
        },
        {
          icon: Calendar,
          title: 'Private Feiern',
          description:
            'Geburtstage, Jubiläen, Gartenpartys – buche Live-Musik für jede private Feier. Von intim bis gross und ausgelassen.',
          link: '/bands',
        },
        {
          icon: Music,
          title: 'Jedes Genre',
          description:
            'Rock, Pop, Jazz, Swing, Soul, Funk, Country, Schlager – finde Bands für jeden Musikgeschmack und jede Stimmung.',
          link: '/bands',
        },
        {
          icon: Award,
          title: 'Erfahrene Bands',
          description:
            'Alle Bands mit Event-Erfahrung und professioneller Ausrüstung. Soundbeispiele und Referenzen direkt auf dem Profil.',
          link: '/bands',
        },
        {
          icon: Check,
          title: 'Direkte Buchung',
          description:
            'Keine Agentur, keine Provision. Kontaktiere Bands direkt, verhandle fair und spare Kosten. Transparente Preisgestaltung.',
          link: '/book-band',
        },
      ]}
      teaserSection={{
        title: 'Was du auf jamnation alles tun kannst',
        description:
          'jamnation ist mehr als nur eine Buchungsplattform. Hier kannst du die Schweizer Musikszene aktiv mitgestalten.',
        items: [
          'Durchsuche hunderte Schweizer Bands und höre Soundbeispiele',
          'Buche Bands direkt ohne Agentur-Provision – transparent und fair',
          'Erstelle ein Bandprofil und werde für Events gebucht',
          'Veröffentliche deine Konzerte und erreiche mehr Publikum',
          'Vernetze dich mit anderen Bands, Musikern und Veranstaltern',
          'Teile deine Bandgeschichten und baue eine Fanbase auf',
        ],
      }}
      seoTeaser={{
        title: 'Live-Musik macht den Unterschied',
        description:
          'Ob Hochzeit, Firmenfeier, Geburtstag oder Festival – Live-Musik verwandelt jedes Event in ein unvergessliches Erlebnis. Auf jamnation findest du Schweizer Bands für jeden Anlass und jedes Budget. Von intimen Acoustic-Sets über elegante Jazz-Ensembles bis zu energiegeladenen Rock- und Partybands: Unsere Plattform bietet dir direkten Zugang zu hunderten professionellen Musikern. Ohne Agentur-Provision, ohne versteckte Kosten – nur faire Preise und transparente Kommunikation. Höre dir Soundbeispiele an, schaue Videos vergangener Auftritte und kontaktiere Bands direkt. Mit jamnation wird die Buchung von Live-Musik zum einfachen und angenehmen Prozess. Deine Gäste werden begeistert sein.',
      }}
      faqItems={[
        {
          question: 'Wie buche ich eine Band über jamnation?',
          answer:
            'Durchsuche die Bands, höre dir Soundbeispiele an und sende dann eine Buchungsanfrage direkt über das Profil oder nutze unser Buchungsformular. Die Band meldet sich dann bei dir.',
        },
        {
          question: 'Was kostet es, eine Band zu buchen?',
          answer:
            'Die Preise variieren je nach Band, Event-Typ, Dauer und Aufwand. Viele Bands nennen Richtwerte auf ihrem Profil. Am besten fragst du direkt für ein individuelles Angebot an.',
        },
        {
          question: 'Wie weit im Voraus sollte ich buchen?',
          answer:
            'Für Hochzeiten und grosse Events empfehlen wir 6-12 Monate Vorlauf. Für kleinere Events reichen oft 2-3 Monate. Beliebte Bands sind an Wochenenden schnell ausgebucht.',
        },
        {
          question: 'Bringen die Bands ihre eigene Technik mit?',
          answer:
            'Die meisten Bands haben eigene PA-Anlagen und Licht. Die genauen Details findest du auf dem Bandprofil oder klärst sie direkt mit der Band.',
        },
        {
          question: 'Kann ich eine Band auch nur für 1-2 Stunden buchen?',
          answer:
            'Ja, viele Bands bieten verschiedene Pakete an – von kurzen Auftritten bis zu ganztägigen Events. Besprich deine Wünsche direkt mit der Band.',
        },
        {
          question: 'Fallen bei jamnation Vermittlungsgebühren an?',
          answer:
            'Nein! jamnation ist kostenlos. Du verhandelst direkt mit der Band ohne Agentur-Provision. Das spart Kosten und ermöglicht transparente Preise.',
        },
        {
          question: 'Können Bands auch spezielle Songs lernen?',
          answer:
            'Viele Bands lernen auf Anfrage spezielle Songs für dein Event (z.B. euren Hochzeitstanz). Frag einfach bei der Buchungsanfrage nach.',
        },
        {
          question: 'Was passiert, wenn die Band kurzfristig absagt?',
          answer:
            'Das ist sehr selten, da alle Bands professionell arbeiten. Am besten klärst du Absicherungen und Backup-Pläne direkt mit der Band im Vertrag.',
        },
      ]}
    />
  );
}
